<template>
    <div>
        <section
            class="pt-2"
            :class="
                cssVariables.attendee - header - bg - color != null
                    ? 'bg-attendee-header'
                    : 'bg-white'
            "
        >
            <div class="container p-6 md:p-12">
                <h1
                    class="title mg-title-header text-center text-dark font-bold"
                    :class="
                        layoutOptions.siteName == 'smacna' ? 'text-white' : ''
                    "
                >
                    Who's Here?
                </h1>
                <!-- <h1 class="title is-size-1  text-center has-dark-text ">Who’s Here?</h1> VMP -->
            </div>
        </section>
        <section
            class="section px-4 md:px-8"
            :class="
                cssVariables.attendee - content - bg - color != null
                    ? 'bg-attendee-content'
                    : 'bg-white'
            "
        >
            <div class="container mx-18">
                <div class="columns lg:px-20">
                    <div class="column is-two-fifths mb-8 lg:pr-10">
                        <h2
                            class="is-size-4 has-text-weight-bold flex justify-center md:justify-start"
                        >
                            <span class="underlined-header block w-full">{{
                                configurableLabels.attendeeListColumnHeader
                                    ? configurableLabels.attendeeListColumnHeader
                                    : "CONNECT WITH ATTENDEES"
                            }}</span>
                            <!-- <span class='underlined-header has-text-info'>CONNECT WITH ATTENDEES</span> vmp -->
                        </h2>

                        <div
                            v-if="isLoading"
                            class="flex flex-row justify-center my-10"
                        >
                            <Spinners />
                        </div>

                        <div
                            v-else
                            v-for="attendee in featuredAttendees"
                            :key="attendee.name"
                        >
                            <attendee-card
                                :title="attendee.title"
                                :name="`${attendee.firstName} ${attendee.lastName}`"
                                :companyName="attendee.companyName"
                                :imgPath="attendee.imgPath"
                                :id="attendee.attendeeId"
                            />
                        </div>
                    </div>
                    <div class="column mb-8">
                        <h2
                            class="is-size-4 has-text-weight-bold flex items-center justify-center md:justify-start underlined-header"
                        >
                            LOOKING FOR SOMEONE IN PARTICULAR?
                        </h2>
                        <attendee-search-form
                            class="my-4"
                        ></attendee-search-form>
                    </div>
                </div>
            </div>
        </section>
        <section
            v-if="layoutOptions.usesAdsSection"
            class="py-12 md:px-4 bg-accent"
        >
            <div class="container">
                <fmi-ads />
            </div>
        </section>
    </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { mapGetters } from "vuex";

import featuredAttendeeVuexModule from "@/store/vuex-modules/getFeaturedAttendees";

import Spinners from "@/components/utilities/Spinners.vue";
import AttendeeCard from "@/components/shared/AttendeeCard";
import AttendeeSearchForm from "@/components/attendee-search/AttendeeSearchForm";
import Ads from "@/components/shared/Ads.vue";

const featuredAttendeeStore = getModule(featuredAttendeeVuexModule);

@Component({
    computed: {
        ...mapGetters(["awsConfig"])
    },
    components: {
        AttendeeCard,
        AttendeeSearchForm,
        Spinners,
        "fmi-ads": Ads
    },
    created() {
        featuredAttendeeStore
            .getFeaturedAttendees({
                tableName: this.awsConfig.attendeeTable,
                isDemoData: !this.awsConfig.attendeeTable
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
})
export default class AttendeeSearch extends Vue {
    prev = "";
    session = "";
    bg = "";
    color = "";
    content = "";
    header = "";
    isLoading = true;

    get configurableLabels() {
        return this.$store.getters.attendeeLabels;
    }

    get layoutOptions() {
        return this.$store.getters.layoutOptions;
    }

    get cssVariables() {
        return this.$store.getters.cssVariables;
    }

    get featuredAttendees() {
        if (!this.awsConfig.attendeeTable) {
            return this.attendeeDummy;
        } else if (featuredAttendeeStore.featuredAttendees) {
            return featuredAttendeeStore.featuredAttendees;
        } else {
            return [];
        }
    }

    attendeeDummy = [
        {
            firstName: "Gabriella",
            MI: "P",
            lastName: "Kato",
            title: "Chief Happiness Officer",
            companyName: "Knock Knock Stuff",
            city: "",
            state: "CA",
            phone: "(703) 838-9777",
            email: "gabriella.kato@knockknockstuff.com",
            lookingNetwork: true,
            lookingCollab: false,
            lookingHiring: true,
            lookingTech: false,
            lookingResearch: false,
            lookingLeadership: true,
            lookingEmployment: false,
            imgPath: "gabriella-kato.png",
            status:
                "Great to be here. Never attended a virtual conference before. This is super cool!",
            biography:
                "I'm in charge of company culture and branding at Knock Knock. This means I'm in charge of new employee onboarding, making sure staff get trained properly, getting staff trained regularly, and organizing company social events.",
            instagramURL: "https://www.instagram.com/msjoannampineda/",
            facebookURL: "https://www.facebook.com/jmpineda",
            linkedInURL: "linkedin.com/gabriellekato",
            favoriteSessions: []
        },
        {
            firstName: "Joe",
            MI: "L",
            lastName: "Allen",
            title: "Talent Acquisition Specialist",
            companyName: "Milwaukee Tool",
            city: "",
            state: "WI",
            phone: "(202) 445-9281",
            email: "jallen@milwaukeetool.com",
            lookingNetwork: true,
            lookingCollab: false,
            lookingHiring: true,
            lookingTech: false,
            lookingResearch: false,
            lookingLeadership: false,
            lookingEmployment: false,
            imgPath: "joe-allen.png",
            status:
                "Holy small world! Just connected with my cousin's best friend from highschool, who I haven't seen in over 16 years. So fun! ",
            biography:
                "Just your friendly neighborhood Recruiter. I help Milwaukee Tool find the best and the brightest. ",
            instagramURL: "https://www.instagram.com/pineda7723/",
            facebookURL: "https://www.facebook.com/alexpineda.sf",
            linkedInURL: "https://www.linkedin.com/in/joannapineda/",
            favoriteSessions: []
        },
        {
            firstName: "Amelia",
            MI: "R",
            lastName: "Perkins",
            title: "Master of Fundom",
            companyName: "Knock Knock Stuff",
            city: "Washington",
            state: "DC",
            phone: "(202) 928-9978",
            email: "amelia.perkins@knockknockstuff.com",
            lookingNetwork: true,
            lookingCollab: true,
            lookingHiring: false,
            lookingTech: true,
            lookingResearch: false,
            lookingLeadership: false,
            lookingEmployment: false,
            imgPath: "amelia-perkins.png",
            status:
                "Ok y’all - the keynote knocked it out of the park. I can leave happy! (Not that I'm going to.... so much more good to come!)",
            biography:
                "At Knock Knock, I bring the fun. In more technical terms, I lead culture practices, and provide expertise and support in the areas of Performance Management, Employee Relations, Employee Engagement, Diversity & Inclusion, Policy and Procedure Development, and HR Compliance.",
            instagramURL: "https://www.instagram.com/leahcmonica/",
            facebookURL: "https://www.facebook.com/leah.croker",
            linkedInURL: "https://www.linkedin.com/in/joannapineda/",
            favoriteSessions: []
        },
        {
            firstName: "Jenny",
            MI: "C",
            lastName: "Parrish",
            title: "Creative Technologist",
            companyName: "McKesson Corporation",
            city: "Arlington",
            state: "VA",
            phone: "(703) 554-2324",
            email: "jennyparrish@mckesson.com",
            lookingNetwork: false,
            lookingCollab: true,
            lookingHiring: false,
            lookingTech: true,
            lookingResearch: true,
            lookingLeadership: false,
            lookingEmployment: true,
            imgPath: "jenny-parrish.png",
            status:
                "LOVED this morning's sesison. This is so true: \"AI will drive the future of customer engagement. Is it on your technology provider's roadmap?\"",
            biography:
                "I'm in charge of coming up with creative ways to use technology to: make the company more productive, help people have more fun, add a creative edge to our projects, and create a recruiting competitve edge for McKesson.",
            instagramURL: "https://www.instagram.com/msjoannampineda/",
            facebookURL: "https://www.facebook.com/jmpineda",
            linkedInURL: "https://www.linkedin.com/in/joannapineda/",
            favoriteSessions: []
        },
        {
            firstName: "Chris",
            MI: "D",
            lastName: "Ayers",
            title: "Amabassador of Buzz",
            companyName: "Knock Knock Stuff",
            city: "Philadelphia",
            state: "PA",
            phone: "(215) 667-9989",
            email: "chris.ayers@knockknockstuff.com",
            lookingNetwork: true,
            lookingCollab: false,
            lookingHiring: false,
            lookingTech: false,
            lookingResearch: false,
            lookingLeadership: false,
            lookingEmployment: true,
            imgPath: "chris-ayers.png",
            status:
                'New-to-me marketing term of the day: "homophily" which describes humans gravitating to others like them.  Important for Data Analytics! ',
            biography:
                "As the Ambassador of Buzz, my job is to create buzz for Knock Knock, in any way that I can. Buzz online, buzz offline. I use social media and live events to generate interest about the ocmpany and our products. I work with schools around the country to supply them with products and create goodwill in communities. Love my job!",
            instagramURL: "https://www.instagram.com/pineda7723/",
            facebookURL: "https://www.facebook.com/alexpineda.sf",
            linkedInURL: "https://www.linkedin.com/in/joannapineda/",
            favoriteSessions: []
        }
    ];
}
</script>
